import type { ExperimentDrivenConfig } from '@rover/rsdk/src/apiClient/latest/model/experimentDrivenConfig';
import { ServiceSetupExperienceEnum } from '@rover/rsdk/src/apiClient/latest/model/serviceSetupExperienceEnum';

export const isSitterInPetCareModesExperiment = (info: {
  experimentDrivenConfig?: ExperimentDrivenConfig;
}): boolean => {
  return (
    info.experimentDrivenConfig?.serviceSetupExperience ===
    ServiceSetupExperienceEnum.pet_care_modes
  );
};
